import { FETCH_ADMIN_INFO } from "../Actions/AdmininfoAction";

const initialState = {
    admininfo: null,
}

const AdminReducer = (state = initialState,action)=>{
    switch(action.type){
        case FETCH_ADMIN_INFO:
            return{
                ...state,
                admininfo: action.payload,
            };
            default:
                return state
    }
}


export default AdminReducer;